import { render, staticRenderFns } from "./DialogueModal.vue?vue&type=template&id=6f4c0501"
import script from "./DialogueModal.vue?vue&type=script&lang=js"
export * from "./DialogueModal.vue?vue&type=script&lang=js"
import style0 from "./DialogueModal.vue?vue&type=style&index=0&id=6f4c0501&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports